import React from 'react';
import TaskDetailsMasterLayer from './TaskDetailsMasterLayer.component';

const HistoryTaskDetail = props => {
    return <TaskDetailsMasterLayer {...props}></TaskDetailsMasterLayer>
};
export default HistoryTaskDetail;
